import { render, staticRenderFns } from "./ValidationInfo.vue?vue&type=template&id=5e16a414&scoped=true"
import script from "./ValidationInfo.vue?vue&type=script&lang=js"
export * from "./ValidationInfo.vue?vue&type=script&lang=js"
import style0 from "./ValidationInfo.vue?vue&type=style&index=0&id=5e16a414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e16a414",
  null
  
)

export default component.exports